<template>
  <small v-if="isLoading" style="color: red;">Loading...</small>
</template>

<script type="text/javascript">
export default {
  props: ['isLoading']
}
</script>